import { useTranslation } from 'react-i18next';

import type { Locale } from '../../../api/types';
import styles from './LocalesTab.module.css';

const ALL_LOCALES: Locale[] = ['ru', 'en', 'be', 'de'];

interface LocalesTabProps {
  activeLocales: Locale[];
  onChange: (locales: Locale[]) => void;
}

// PARA-106, AC-4/AC-5: чекбоксы активности из 4 поддерживаемых языков.
export function LocalesTab({ activeLocales, onChange }: LocalesTabProps): JSX.Element {
  const { t } = useTranslation();

  const toggle = (locale: Locale): void => {
    onChange(
      activeLocales.includes(locale)
        ? activeLocales.filter((item) => item !== locale)
        : [...activeLocales, locale],
    );
  };

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>{t('settings.locales.description')}</legend>
      <div className={styles.options}>
        {ALL_LOCALES.map((locale) => (
          <label key={locale} className={styles.option}>
            <input
              className={styles.checkbox}
              type="checkbox"
              checked={activeLocales.includes(locale)}
              onChange={() => toggle(locale)}
            />
            {locale.toUpperCase()}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
